import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SlideFromContainer from './SlideFromContainer';
import ClientProvider from './client';
export default createDemo(import.meta.url, SlideFromContainer, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/transitions/demos/slide-from-container/SlideFromContainer.tsx",
    "fileName": "SlideFromContainer.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\nimport Paper from '@mui/material/Paper';\nimport Slide from '@mui/material/Slide';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst icon = (\n  <Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>\n    <svg width=\"100\" height=\"100\">\n      <Box\n        component=\"polygon\"\n        points=\"0,100 50,00, 100,100\"\n        sx={(theme) => ({\n          fill: theme.palette.common.white,\n          stroke: theme.palette.divider,\n          strokeWidth: 1,\n        })}\n      />\n    </svg>\n  </Paper>\n);\n\nexport default function SlideFromContainer() {\n  const [checked, setChecked] = React.useState(false);\n  const containerRef = React.useRef<HTMLElement>(null);\n\n  const handleChange = () => {\n    setChecked((prev) => !prev);\n  };\n\n  return (\n    <Box\n      sx={{\n        width: 240,\n        borderRadius: 2,\n        border: '1px solid',\n        borderColor: 'divider',\n        backgroundColor: 'background.default',\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box sx={{ p: 2, height: 200, overflow: 'hidden' }} ref={containerRef}>\n        <FormControlLabel\n          control={<Switch checked={checked} onChange={handleChange} />}\n          label=\"Show from target\"\n        />\n        <Slide in={checked} container={containerRef.current}>\n          {icon}\n        </Slide>\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 53,
        "focusedLines": 9,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\nimport Paper from '@mui/material/Paper';\nimport Slide from '@mui/material/Slide';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst icon = (\n  <Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>\n    <svg width=\"100\" height=\"100\">\n      <Box\n        component=\"polygon\"\n        points=\"0,100 50,00, 100,100\"\n        sx={(theme) => ({\n          fill: theme.palette.common.white,\n          stroke: theme.palette.divider,\n          strokeWidth: 1,\n        })}\n      />\n    </svg>\n  </Paper>\n);\n\nexport default function SlideFromContainer() {\n  const [checked, setChecked] = React.useState(false);\n  const containerRef = React.useRef<HTMLElement>(null);\n\n  const handleChange = () => {\n    setChecked((prev) => !prev);\n  };\n\n  return (\n    <Box\n      sx={{\n        width: 240,\n        borderRadius: 2,\n        border: '1px solid',\n        borderColor: 'divider',\n        backgroundColor: 'background.default',\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Box sx={{ p: 2, height: 200, overflow: 'hidden' }} ref={containerRef}>\n        <FormControlLabel\n          control={<Switch checked={checked} onChange={handleChange} />}\n          label=\"Show from target\"\n        />\n        <Slide in={checked} container={containerRef.current}>\n          {icon}\n        </Slide>\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "p"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "height"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "200"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "overflow"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "hidden",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "ref"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "containerRef"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "checked"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "checked"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "          ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Show from target",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            "        />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Slide"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "in"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "checked"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "container"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "containerRef"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "current"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "          ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "icon"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Slide"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 50
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 53,
    "focusedLines": 9,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Switch",
      "@mui/material/Paper",
      "@mui/material/Slide",
      "@mui/material/FormControlLabel"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
